import { call, put, takeEvery } from 'redux-saga/effects';
import * as actionTypes from '../../../constants/ActionTypes/AdminPortal/HardwareInclusiveCounter';
import { LOCALSESSIONDATAKEYS, _ADMINISTRATOR_API_ENDPOINTS } from '../../../constants/AppConstants';
import { _CALLPOSTAPI_WITHQS } from '../../../api/apiHandler';
import i18next from 'i18next';
import { getLocalSessionData } from '../../../utils/Authentication/handleUserSession';

function _addHardwareInclusiveCounter(printerTypeId, availableUnits, countryCode, isEnabled) {
  const endpoint = _ADMINISTRATOR_API_ENDPOINTS.HARDWARE_INCLUSIVE_COUNTER.ADD;
  const payload = {
    "printerTypeId": printerTypeId,
    "availableUnits": availableUnits,
    "countryCode": countryCode,
    "isEnabled": isEnabled,
    "createdBy": "ArchanaV3"
  }
  const queryString = {
    params: {
      userId: getLocalSessionData(LOCALSESSIONDATAKEYS.UID)
    }
  }
  return _CALLPOSTAPI_WITHQS(endpoint, payload, queryString)
    .then(response => response)
    .catch((error) => {
      throw error;
    });
}

function* handleAdd(action) {
  try {
    const printerTypeId = action.printerTypeId
    const availableUnits = action.availableUnits
    const countryCode = action.countryCode
    const isEnabled = action.isEnabled
    const result = yield call(_addHardwareInclusiveCounter, printerTypeId, availableUnits, countryCode, isEnabled);
    yield put({ type: actionTypes.ADD_HARDWARE_INCLUSIVE_COUNTER_SUCCESS, data: result });

  } catch (e) {
    yield put({
      type: actionTypes.ADD_HARDWARE_INCLUSIVE_COUNTER_FAILURE,
      message: i18next.t('Admintranslation:ADMIN_COMMON_ERRORS.TECHNICAL_ERROR')
    });
  }
}

function* HardwareInclusiveStockCounter_ADD() {
  yield takeEvery(actionTypes.ADD_HARDWARE_INCLUSIVE_COUNTER_INIT, handleAdd);
}

export default HardwareInclusiveStockCounter_ADD;